/**
 * VideoUpload widget utility helpers.
 *
 * Provides factory to build video event handlers used by the widget so they can
 * be unit tested independently from DOM/media support in jsdom.
 */
import { Config } from './types';

export interface VideoHandlerDeps {
  editing: boolean;
  widgetState: Widget<Config>;
  trackVideo: (action: string, extras?: Record<string, any>) => void;
}

/**
 * Build handlers for video media events. Suppresses tracking when editing.
 * @param deps dependencies including editing flag, widget state and track function.
 * @returns object with event handler functions.
 */
export function buildVideoEventHandlers(deps: VideoHandlerDeps) {
  const { editing, trackVideo } = deps;
  // const label = widgetState.config.analyticsLabel;

  const handle = (eventName: string, videoEl?: HTMLVideoElement) => {
    if (editing) return; // suppress while in builder edit mode
    trackVideo(`video_widget_${eventName}`, {
      duration: videoEl?.duration ?? null,
      currentTime: videoEl?.currentTime ?? null,
      // widgetAnalyticsLabel: label,
    });
  };

  return {
    onPlay: (videoEl?: HTMLVideoElement) => handle('play', videoEl),
    onPause: (videoEl?: HTMLVideoElement) => handle('pause', videoEl),
    onSeeked: (videoEl?: HTMLVideoElement) => handle('seeked', videoEl),
    onEnded: (videoEl?: HTMLVideoElement) => handle('ended', videoEl),
  };
}
